import {Injectable} from '@angular/core';
import {NavigationEnd, Router, Event} from '@angular/router';
import {SubscriptionsService} from './subscriptions.service';
import {Subscription} from 'rxjs';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';

interface Actions {
  REG: string;
  LOG: string;
  CHPW: string;
  PAY: string;
  DEPOSIT: string;
}

@Injectable()
export class ActionService {
  action: any;
  actions: Actions;
  cartSubscription: Subscription;
  redirectAfter: any;
  constructor(private router: Router, private subscriptionsService: SubscriptionsService, private lotteriesService: LotteriesService) {
    this.actions = {
      REG: 'registration',
      LOG: 'login',
      CHPW: 'change_password',
      PAY: 'pay',
      DEPOSIT: 'deposit'
    };
  }

  public checkParamsUrl (url): any[] {
    if (url) {
      if (url.indexOf('add-funds') > -1 ||
        url.indexOf('my-entries') > -1 ||
        url.indexOf('my-account') > -1 ||
        url.indexOf('settings') > -1 ||
        url.indexOf('bonuses') > -1 ||
        url.indexOf('verification') > -1 ||
        url.indexOf('my-transactions') > -1 ||
        url.indexOf('contact-preferences') > -1 ||
        url.indexOf('user-limits') > -1) {
        const redirectUrl = url.split('/');
        return redirectUrl.length > 1 ? [redirectUrl[redirectUrl.length - 2], redirectUrl[redirectUrl.length - 1]] : [];
      }
    } else {
      return [];
    }
  }

  public checkForCartRedirection(language) {
      if (this.router.url.toString().includes('/cart')) {
          this.subscriptionsService.emitPay(true);
          if (this.cartSubscription) {
              this.cartSubscription.unsubscribe();
          }
      } else {
      setTimeout(() => {
          this.checkForCartRedirection(language);
      }, 500);
    }
  }

  public goToAction(params, language, loggedIn) {
      if (params['paymentStatusCheck']) {
          if (params['transactionId']) {
              const body = 'TransactionId=' + params['transactionId'];
              this.lotteriesService.postData(globals.appDomain + '/payments/getTransactionStatus/status.json', body).subscribe(response => {
                 if (response && response.message.status === 'OK') {
                    if (response.message.transactionStatus === 'success') {
                        const url = localStorage.getItem('success3d');
                        const url_mp = url.split('?');
                        let urlToNav = '';
                        if (url_mp[0].includes('/en/')) {
                          const tmpURL = url_mp[0].split('/en/');
                          urlToNav = tmpURL[1];
                        } else if (url_mp[0].includes('/de/')) {
                          const tmpURL = url_mp[0].split('/de/');
                          urlToNav = tmpURL[1];
                        } else {
                          urlToNav = null;
                        }
                      const sendParams = [];
                      if (url_mp[1] !== undefined) {
                        const params = url_mp[1].split('&');
                        params.forEach((element, index) => {
                          const param = element.split('=');
                          sendParams[param[0]] = param[1];
                        });
                      }
                      let urlToCart = [];
                      if (urlToNav && urlToNav.includes('cart')) {
                        localStorage.removeItem('cart');
                        urlToCart = urlToNav.split('/');
                        urlToNav = null;
                      }
                      setTimeout(() => {
                        if (urlToNav) {
                          this.router.navigate(['/' + language, urlToNav], { queryParams: sendParams});
                        } else if (urlToCart && urlToCart[0] && urlToCart[1]) {
                          this.router.navigate(['/' + language, urlToCart[0], urlToCart[1]], { queryParams: sendParams});
                        } else if (urlToCart && urlToCart[0]) {
                          this.router.navigate(['/' + language, urlToCart[0]], { queryParams: sendParams});
                        }  else {
                          this.router.navigate(['/'], { queryParams: sendParams});
                        }
                      }, 3000);
                    }
                     if (response.message.transactionStatus === 'failed') {
                          if (response.message.errorMessage) {
                            localStorage.setItem('error3dSecure', response.message.errorMessage);
                          }
                       const url = localStorage.getItem('fail3d');
                       if (url.includes('paymentStatus=failed') || url.includes('paymentStatus=fail')) {
                         const url_mp = url.split('?');
                         let urlToNav = '';
                         if (url_mp[0].includes('/en/')) {
                           const tmpURL = url_mp[0].split('/en/');
                           urlToNav = tmpURL[1];
                         } else if (url_mp[0].includes('/de/')) {
                           const tmpURL = url_mp[0].split('/de/');
                           urlToNav = tmpURL[1];
                         } else {
                           urlToNav = null;
                         }
                         const sendParams = [];
                         if (url_mp[1] !== undefined) {
                           const params = url_mp[1].split('&');
                           params.forEach((element, index) => {
                             const param = element.split('=');
                             sendParams[param[0]] = param[1];
                           });
                         }
                         setTimeout(() => {
                           if (urlToNav) {
                             this.router.navigate(['/' + language, urlToNav], { queryParams: sendParams});
                           } else {
                             this.router.navigate(['/'], { queryParams: sendParams});
                           }
                         }, 3000);
                       }
                     }
                     if (response.message.transactionStatus === 'pending') {
                       this.router.navigate(['/' + language, 'cart', 'payment-pending']);
                     }
                 }
              });
          }
      }
    if (params['action']) {
      if (params['redirectUrl']) {
        const url = params['redirectUrl'].toLowerCase();
        if (params['action'] === this.actions.PAY) {
            this.cartSubscription = this.router.events.subscribe((event: Event) => {
                if (event instanceof NavigationEnd) {
                    if (this.router.url.toString().includes('/cart')) {
                        this.checkForCartRedirection(language);
                    }
                }
            });
            this.router.navigate(['/' + language + '/cart']);
        }
        if (params['action'] === this.actions.REG && !loggedIn && params['action'] !== this.actions.PAY) {
            this.action = 'reg';
        }
        if (params['action'] === this.actions.LOG && !loggedIn && params['action'] !== this.actions.PAY) {
            this.action = 'log';
        }
        if (params['action'] === this.actions.CHPW && !loggedIn) {
            this.action = 'chpw';
        }
        if (params['action'] === this.actions.DEPOSIT) {
            this.action = 'deposit';
        }
      } else {
        if (params['action'] === this.actions.LOG && !loggedIn) {
          setTimeout(() => {
            this.subscriptionsService.emitRegisterOrLogin(true);
          }, 2000);
        }
        if (params['action'] === this.actions.REG && !loggedIn) {
          setTimeout(() => {
            this.subscriptionsService.emitLogin(false);
            this.subscriptionsService.emitRegister(true);
          }, 2000);
        }
        if (params['action'] === this.actions.CHPW && !loggedIn) {
          setTimeout(() => {
            this.subscriptionsService.emitLogin(false);
            this.subscriptionsService.emitRegister(false);
            this.subscriptionsService.emitChangePassword(true);
          }, 2000);
        }
          if (params['action'] === this.actions.DEPOSIT) {
              setTimeout(() => {
                  if (loggedIn) {
                      this.subscriptionsService.triggerDepositService(true);
                  } else {
                      this.subscriptionsService.emitFakeCart(true);
                      this.subscriptionsService.emitRegisterOrLogin(true);
                  }
              }, 1000);
          }
          if (params['action'] === this.actions.PAY) {
               this.router.navigate(['/' + language + '/cart']);
              setTimeout(() => {
                  this.checkForCartRedirection(language);
              }, 3000);
          }
      }
    }

    if (params['redirectUrl'] && !params['init']) {
      let url;
      const paramsUrl = this.checkParamsUrl(params['redirectUrl']);
      if (paramsUrl && paramsUrl.length > 1) {
        url = paramsUrl[0].toLowerCase();
        localStorage.setItem('dashboardStatus', paramsUrl[1].toLowerCase());
      } else {
        url = params['redirectUrl'].toLowerCase();
      }
      url = url.indexOf('/') == 0 ? url.substring(1) : url;
        if ((this.action === 'log' || this.action === 'reg') && !loggedIn) {
            setTimeout(() => {
                this.subscriptionsService.emitRegisterOrLogin(true);
                this.action = '';
                this.redirectAfter = '/' + language + '/' + url;
            }, 500);
        } else {
          this.router.navigateByUrl('/' + language + '/' + url).then( (resolve) => {
                  if (this.action === 'deposit') {
                      setTimeout(() => {
                          if (loggedIn) {
                              this.subscriptionsService.triggerDepositService(true);
                          } else {
                              this.subscriptionsService.emitFakeCart(true);
                              this.subscriptionsService.emitRegisterOrLogin(true);
                          }
                          this.action = '';
                      }, 500);
                  }
                    if (this.action === 'chpw') {
                        setTimeout(() => {
                            this.subscriptionsService.emitLogin(false);
                            this.subscriptionsService.emitRegister(false);
                            this.subscriptionsService.emitChangePassword(true);
                            this.action = '';
                        }, 500);
                    }
              }
            );
        }
    }
  }
}
